// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8b15eb9ee4e83703975ba335ca7a7502145b55ee.chunk.js";
};